import { UseCase } from '@/shared/application/UseCase';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { AppTypeDentalOrVision, DentalAndVisionApplication } from '@/application/shared/domain/DentalAndVisionApplication';
import { UUID } from '@hfc/common/src/types/UUID';
import { SfApiResponse } from '@hfc/ui-core';

export class GetApplicationUseCase implements UseCase<[AppTypeDentalOrVision, UUID, boolean?], SfApiResponse<DentalAndVisionApplication>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (params: [AppTypeDentalOrVision, UUID, boolean?]): Promise<SfApiResponse<DentalAndVisionApplication>> {
    const [applicationType, uuid, applicationFinished] = params;

    return await this.repository.getApplication(applicationType, uuid, applicationFinished);
  }

}
